import { TourProvider } from '@reactour/tour'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import DataContextContainer from 'contexts/DataContextContainer'
import AuthProvider from 'providers/auth'
import GlobalStyle from 'style/globalStyle'
import Routes from './routes'
import './services/i18'

const queryClient = new QueryClient()

function App() {
  return (
    <div className="App">
      <GlobalStyle />
      <QueryClientProvider client={queryClient}>
        <DataContextContainer>
          <AuthProvider>
            <TourProvider
              showBadge={false}
              scrollSmooth
              padding={{
                mask: 15,
                popover: 25,
              }}
              styles={{
                popover: (base) => ({
                  ...base,
                  maxWidth: '75vw',
                  top: '3vh',
                }),
              }}
            >
              <Routes />
            </TourProvider>
          </AuthProvider>
        </DataContextContainer>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </div>
  )
}

export default App
